export const mapOptions = (customOptions = {}) => ({
  fullscreenControl: false,
  clickableIcons: false, //desactiva funcion de click a los iconos
  disableDefaultUI: false,
  panControl: false,
  styles: [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#aadaff" }],
    },
  ],
  ...customOptions,
});
